import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const QuickAccessPanel = ({ userBroadcasts, notifications, suggestedChannels, onCreateBroadcast, onViewChannel }) => {
  return (
    <div className="quick-access-panel space-y-6">
      <div className="user-broadcasts-section bg-card rounded-lg border border-border p-4">
        <div className="section-header flex items-center justify-between mb-4">
          <h3 className="text-sm font-heading font-semibold text-foreground uppercase tracking-wide">
            Мои эфиры
          </h3>
          <button
            onClick={onCreateBroadcast}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors duration-200 text-sm font-heading font-medium"
          >
            <Icon name="Plus" size={16} color="currentColor" />
            <span>Создать</span>
          </button>
        </div>

        {userBroadcasts?.length > 0 ? (
          <div className="broadcasts-list space-y-3">
            {userBroadcasts?.map((broadcast) => (
              <div key={broadcast?.id} className="broadcast-item flex items-center gap-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200 cursor-pointer">
                <div className="broadcast-icon w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Radio" size={20} color="var(--color-primary)" />
                </div>
                <div className="broadcast-info flex-1 min-w-0">
                  <p className="text-sm font-heading font-medium text-foreground truncate">
                    {broadcast?.title}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {broadcast?.listenerCount} слушателей
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state text-center py-6">
            <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mx-auto mb-3">
              <Icon name="Radio" size={24} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-sm text-muted-foreground">
              У вас пока нет эфиров
            </p>
          </div>
        )}
      </div>
      <div className="notifications-section bg-card rounded-lg border border-border p-4">
        <div className="section-header flex items-center justify-between mb-4">
          <h3 className="text-sm font-heading font-semibold text-foreground uppercase tracking-wide">
            Уведомления
          </h3>
          {notifications?.length > 0 && (
            <span className="w-5 h-5 rounded-full bg-error text-error-foreground text-xs flex items-center justify-center font-mono">
              {notifications?.length}
            </span>
          )}
        </div>

        {notifications?.length > 0 ? (
          <div className="notifications-list space-y-3">
            {notifications?.map((notification) => (
              <div key={notification?.id} className="notification-item flex items-start gap-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200 cursor-pointer">
                <div className="notification-avatar w-8 h-8 rounded-full overflow-hidden bg-muted flex-shrink-0">
                  <Image 
                    src={notification?.avatar}
                    alt={notification?.avatarAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="notification-content flex-1 min-w-0">
                  <p className="text-sm text-foreground line-clamp-2 mb-1">
                    {notification?.message}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {notification?.time}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state text-center py-6">
            <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mx-auto mb-3">
              <Icon name="Bell" size={24} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-sm text-muted-foreground">
              Нет новых уведомлений
            </p>
          </div>
        )}
      </div>
      <div className="suggested-channels-section bg-card rounded-lg border border-border p-4">
        <div className="section-header mb-4">
          <h3 className="text-sm font-heading font-semibold text-foreground uppercase tracking-wide">
            Рекомендуемые каналы
          </h3>
        </div>

        <div className="channels-list space-y-3">
          {suggestedChannels?.map((channel) => (
            <div key={channel?.id} className="channel-item flex items-center gap-3 p-2 rounded-lg hover:bg-muted transition-colors duration-200">
              <div className="channel-avatar w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <Image 
                  src={channel?.avatar}
                  alt={channel?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="channel-info flex-1 min-w-0">
                <p className="text-sm font-heading font-medium text-foreground truncate">
                  {channel?.name}
                </p>
                <p className="text-xs text-muted-foreground">
                  {channel?.subscriberCount} подписчиков
                </p>
              </div>
              <button
                onClick={() => onViewChannel(channel)}
                className="px-3 py-1.5 bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-colors duration-200 text-xs font-heading font-medium flex-shrink-0"
              >
                Подписаться
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAccessPanel;